var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAioaIconType6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1278 -246)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1278 246)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 66,
    r: 66,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 66,
    r: 61,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1307.996 281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.908,38.189H8.954v4.477H0V29.235H44.77V42.666H35.816V38.189H26.862v44.77h8.954v8.954H8.959V82.959h8.95Z",
    transform: "translate(26.863 -29.235)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.7,175.411v13.431h-8.954v-4.477h-4.477V206.75h4.477V215.7H242.836V206.75h4.477V184.365h-4.477v4.477h-8.954V175.411H269.7Z",
    transform: "translate(-233.881 -153.026)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAioaIconType6);
export default __webpack_public_path__ + "static/media/aioa-icon-type-6.db3dcf1d58edc46a97386d149688b31e.svg";
export { ForwardRef as ReactComponent };